module.exports = __webpack_public_path__ + "img/je.c73e57ab.svg";